import { useCurrentJobId } from "@/hooks/useCurrentJobId";

import { useGetJobsByCompanyId } from "./useGetJobsByCompanyId";

export function useCurrentJobResponse() {
  const currentJobId = useCurrentJobId();
  const query = useGetJobsByCompanyId();

  const currentJobResponse = query.data?.find(
    (jr) => jr.job.id === currentJobId,
  );

  return {
    ...query,
    data: currentJobResponse,
  };
}
